import AppRouter from "./routes/AppRouter";
import "./styles/paras-home.css";

export default function App() {
  return <AppRouter />;
}
